/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */

/*
 * Disabled the following rules:
 * @typescript-eslint/naming-convention
 * @typescript-eslint/no-empty-interface
 * @typescript-eslint/no-unused-vars
 * as MUI theme override required override interfaces
 *
 * More info on custom theming for Typography can be found here
 * https://mui.com/material-ui/customization/typography/#adding-amp-disabling-variants
 */
import {ThemeOptions} from "@mui/material/styles";
import {breakpointsTheme} from "assets/theming/breakpoints.theme";

declare module "@mui/material/styles" {
	interface TypographyVariants {
		body3: React.CSSProperties;
		body4: React.CSSProperties;
		miscRegular: React.CSSProperties;
		miscSemiBold: React.CSSProperties;
		pageName: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		body3?: React.CSSProperties;
		body4?: React.CSSProperties;
		miscRegular?: React.CSSProperties;
		miscSemiBold?: React.CSSProperties;
		pageName?: React.CSSProperties;
	}
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
	interface TypographyPropsVariantOverrides {
		body3: true;
		body4: true;
		miscRegular: true;
		miscSemiBold: true;
		pageName: true;
	}
}

export const typographyTheme: ThemeOptions = {
	typography: {
		allVariants: {
			fontFamily: "var(--fontFamilyBase)",
		},

		h1: {
			fontWeight: 600,
			fontSize: "40px",
			[breakpointsTheme.down("md")]: {
				fontSize: "32px",
			},
		},
		h2: {
			fontWeight: 600,
			fontSize: "32px",
			[breakpointsTheme.down("md")]: {
				fontSize: "28px",
			},
		},
		h3: {
			fontWeight: 600,
			fontSize: "28px",
			[breakpointsTheme.down("md")]: {
				fontSize: "24px",
			},
		},
		h4: {
			fontWeight: 600,
			fontSize: "24px",
			[breakpointsTheme.down("md")]: {
				fontSize: "20px",
			},
		},
		h5: {
			fontWeight: 600,
			fontSize: "20px",
			[breakpointsTheme.down("md")]: {
				fontSize: "16px",
			},
		},
		h6: {
			fontWeight: 600,
			fontSize: "16px",
		},
		body1: {
			fontWeight: 600,
			fontSize: "16px",
		},
		body2: {
			fontWeight: 600,
			fontSize: "14px",
		},
		body3: {
			fontSize: "12px",
			lineHeight: "16px",
		},
		body4: {
			fontFamily: "var(--fontFamilySecond)",
		},
		miscRegular: {
			fontWeight: 400,
			fontSize: "12px",
			lineHeight: "14px",
		},
		miscSemiBold: {
			fontWeight: 600,
			fontSize: "10px",
			lineHeight: "14px",
		},
	},
	components: {
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					body3: "p", // Map the new variant to render a 'p' tag by default
					body4: "p", // Map the new variant to render a 'p' tag by default
				},
			},
		},
	},
};
